import { render, staticRenderFns } from "./Join-Selector.vue?vue&type=template&id=42553b76&lang=pug"
import script from "./Join-Selector.vue?vue&type=script&lang=ts"
export * from "./Join-Selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports